"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tooltipModule = _interopRequireDefault(require("./tooltip.module.scss"));
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '' : _ref$size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'dark' : _ref$variant;
  var node = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var handleClick = (0, _react.useCallback)(function (event) {
    var target = event.target;
    if (node.current.contains(target)) {
      event.stopPropagation();
      return;
    }
    setIsVisible(false);
  }, [node, setIsVisible]);
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleClick);
    return function () {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick]);
  var showTooltip = title ? function (e) {
    e.stopPropagation();
    setIsVisible(true);
  } : undefined;
  var hideTooltip = title ? function (e) {
    e.preventDefault();
    setIsVisible(false);
  } : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_tooltipModule.default['tooltip'], _tooltipModule.default["tooltip--".concat(variant)], containerClassName),
    ref: node,
    onClick: showTooltip,
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    "data-testid": "tooltip-wrapper"
  }, children, title && isVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_tooltipModule.default['tooltip-content'], _tooltipModule.default[size], _tooltipModule.default[position], className),
    "data-testid": "tooltip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _tooltipModule.default['hover-area']
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _tooltipModule.default.arrow
  }), title));
};
exports.Tooltip = Tooltip;